// MUI
import { Stack, Tooltip } from "@mui/material";

// Components
import { LoadingSpinner } from "../LoadingSpinner";
import SimpleIconButton from "../Buttons/SimpleIconButton";

// Interfaces
import { IActionRefreshOnDemandProps } from "./interfaces";

// Images
import { ReactComponent as Refresh } from "@/assets/icons/common/refresh.svg";

export const ActionRefreshOnDemand = (props: Readonly<IActionRefreshOnDemandProps>) => {
	const { tooltip = "", loadingProps, disabled = false, loading = false, onClick = () => {} } = props;

	const handleClick = () => {
		onClick();
	};

	return (
		<Stack direction="row" alignItems={"center"} spacing={1}>
			{!loading && (
				<Stack>
					<Tooltip title={tooltip} placement="top" arrow classes={{ tooltip: "!font-regular-sans" }}>
						<Stack>
							<SimpleIconButton disabled={disabled} icon={<Refresh />} onClick={handleClick} />
						</Stack>
					</Tooltip>
				</Stack>
			)}

			{Boolean(loading) && (
				<Stack>
					<LoadingSpinner {...loadingProps} />
				</Stack>
			)}
		</Stack>
	);
};
